<template>
	<div>
		<div v-for="type in reportItems" :key="type.type" class="type">
			<div class="text-xs-left">
				<h2 style="margin-bottom: 20px; margin-top:10px;">
					{{ getTypeFriendly(type.type, true) }}
				</h2>
				<h5 v-if="type.type == '3'">
					This is the team members opportunity to provide qualified and specific feedback to their Manager
				</h5>
			</div>
			<div v-for="t in type.items" :key="t.id">
				<div class="text-xs-left">
					<h4 style="margin-top:30px; margin-bottom:20px; color: rgba(0,0,0,0.54);">
						{{ t.category }}
					</h4>
				</div>
				<div v-for="s in t.items" :key="s.id" class="item">
					<v-layout row wrap>
						<v-flex text-xs-left xs12>
							<div>
								<div
									style="border-left-color: lightgray;
                    padding-left: 10px; padding-right: 10px;"
									:class="{ 'item-text': true, 'na-text': s.result == '-1', 'green-text': s.result == '2', 'amber-text': s.result == '1', 'red-text': s.result == '0' }"
								>
									<table>
										<tr>
											<td style="width: 1px;">
												<v-btn :class="{ 'item-btn': true, success: s.result == '2', warning: s.result == '1', error: s.result == '0', disabled: true }" fab small>
													<v-icon v-if="s.result != '-1'" style="font-size: 14px;">{{ getIcon(s.result) }}</v-icon>
													<span v-if="s.result == '-1'" style="font-size:9px;">n/a</span>
												</v-btn>
											</td>

											<td>{{ s.item.item }}</td>
										</tr>
									</table>
								</div>

								<div v-for="outcome in s.outcomes" :key="outcome.id" style="margin-left:20px;">
									<div
										style="border-left-color: lightgray;
                    padding-left: 10px; padding-right: 10px;"
										:class="{ 'item-text': true, 'na-text': s.result == '-1', 'green-text': outcome.result == '2', 'amber-text': outcome.result == '1', 'red-text': outcome.result == '0' }"
									>
										<table>
											<tr>
												<td style="width: 1px;">
													<v-menu transition="scale-transition" lazy right absolute offset-y>
														<v-btn slot="activator" :class="{ 'item-btn': true, success: outcome.result == '2', warning: outcome.result == '1', error: outcome.result == '0', disabled: true }" fab small>
															<v-icon style="font-size: 14px;">keyboard_arrow_right</v-icon>
														</v-btn>

														<div style="padding:5px; background-color: #fff">
															<v-btn :title="greenDescription" color="#4caf50" fab small dark style="height:30px; width: 30px;"> </v-btn>
															<v-btn :title="amberDescription" color="#ffc107" fab small dark style="height:30px; width: 30px;"> </v-btn>
															<v-btn :title="redDescription" color="#f44336" fab small dark style="height:30px; width: 30px;"> </v-btn>
															<v-btn :title="naDescription" small style="height:30px; width: 30px;">N/A</v-btn>
														</div>
													</v-menu>
												</td>

												<td>{{ outcome.outcome.outcome }}</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</v-flex>

						<v-flex xs12>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<table v-if="s.comment != null" class="comment" v-on="on">
										<tr>
											<td>
												<v-avatar size="36px">
													<img :src="getAvatar(filledOutBy.id)" alt="avatar" class="avatar-img" />
												</v-avatar>
											</td>
											<td>
												<v-subheader>{{ s.comment }}</v-subheader>
											</td>
										</tr>
									</table>
								</template>
								<span>Comment from {{ filledOutBy.fullName }}</span>
							</v-tooltip>
						</v-flex>
					</v-layout>

					<v-divider style="margin-bottom:20px;"></v-divider>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import avatarMixin from '@/mixins/avatarMixin';
	import trafficLightsMixin from '@/mixins/trafficLightsMixin';

	export default {
		props: {
			reportItems: {
				required: true
			},
			filledOutBy: {
				required: true
			}
		},
		methods: {
			getIcon(result) {
				switch (result) {
					case -1:
						return 'radio_button_unchecked';
						break;
					case 0:
						return 'clear';
						break;
					case 1:
						return 'remove';
						break;
					case 2:
						return 'check';
						break;
					default:
						return 'keyboard_arrow_right';
						break;
				}
			}
		},
		mixins: [typeFriendlyMixin, avatarMixin, trafficLightsMixin]
	};
</script>

<style>
	.comment {
		margin-top: 5px;
		margin-bottom: 5px;
	}
	button.disabled {
		color: rgba(0, 0, 0, 0.87);
		box-shadow: none !important;
		pointer-events: none;
	}
</style>
